module.exports = __webpack_public_path__ + "static/media/Licorice-Regular.ef9965e8.ttf";